import CheckIcon from '@mui/icons-material/Check'
import ExpandLessIcon from '@mui/icons-material/ExpandLess'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import MenuIcon from '@mui/icons-material/Menu'
import AppBar from '@mui/material/AppBar'
import Avatar from '@mui/material/Avatar'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Container from '@mui/material/Container'
import IconButton from '@mui/material/IconButton'
import Menu from '@mui/material/Menu'
import MenuItem from '@mui/material/MenuItem'
import Toolbar from '@mui/material/Toolbar'
import Tooltip from '@mui/material/Tooltip'
import Typography from '@mui/material/Typography'
import React, { useState } from 'react'

import HelpOutlineIcon from '@mui/icons-material/HelpOutline'
import SearchIcon from '@mui/icons-material/Search'
import TourIcon from '@mui/icons-material/Tour'
import { Alert, Divider, Snackbar } from '@mui/material'
import { grey } from '@mui/material/colors'
import { useNavigate } from 'react-router-dom'
import { IS_LITE } from '../../app/const'
import { useAppDispatch, useAppSelector } from '../../app/hooks'
import { selectAnalysisData, selectDomain, selectDomainCss } from '../analysis/AnalysisSlice'
import { selectAuthUser, selectIsAuth, selectIsNotOrgUser, signOutAsync } from '../auth/AuthSlice'
import { getLogoObjFit, selectCustomize, selectIsPreview } from '../customize/CustomizeSlice'
export interface ResponsiveAppBarProps {
  onOpenTour?: () => void
}

const ResponsiveAppBar = (props: ResponsiveAppBarProps) => {
  const navigate = useNavigate()
  const isAuth = useAppSelector(selectIsAuth)
  const user = useAppSelector(selectAuthUser)
  const domain = useAppSelector(selectDomain)
  const domainCss = useAppSelector(selectDomainCss)
  const isNotOrgUser = useAppSelector(selectIsNotOrgUser)
  const customize = useAppSelector(selectCustomize)
  const analysisData = useAppSelector(selectAnalysisData)
  const isPreview = useAppSelector(selectIsPreview)
  const dispatch = useAppDispatch()

  const [logoutSuccess, setLogoutSuccess] = useState(false)

  const [anchorElNav, setAnchorElNav] = useState<null | HTMLElement>(null)
  const [anchorElUser, setAnchorElUser] = useState<null | HTMLElement>(null)

  const handleLogoutSuccess = () => { setLogoutSuccess(false) }

  const adminItems = user?.authorities.filter(e => e.authority === 'ROLE_ADMIN').length ? [{ path: '/admin', label: 'Admin' }, { path: '/admin/slugs', label: 'Slugs' }] : []

  return (
    domain || isPreview ? <Box>
      <AppBar position="static" sx={{ marginBottom: 4, backgroundColor: domainCss?.toolbarBG, display: 'flex' }}>
        <Box sx={{ display: 'flex', height: `${domainCss?.logoHeight ? domainCss?.logoHeight + 25 : 75}px`, alignItems: 'center', pl: 3 }}>
          <img src={customize?.logoUrl ? customize?.logoUrl
            : customize?.logoB64 ? customize?.logoB64
              : `/images/domain-logos/${domain}.png`} style={{
                objectFit: getLogoObjFit(customize?.logoObjFit)
                , maxHeight: `${domainCss?.logoHeight ?? 50}px`
              }} alt={domain} />
        </Box>
      </AppBar>
    </Box> : IS_LITE ? <Box sx={{ marginTop: 5 }}></Box> : <AppBar position="static" sx={{ marginBottom: 4, backgroundColor: domainCss?.toolbarBG }}>
      <Container maxWidth="xl" sx={{ backgroundColor: domainCss?.toolbarBG }}>
        <Toolbar disableGutters sx={{ backgroundColor: domainCss?.toolbarBG }}>
          <Box sx={{ flexGrow: 1, display: { xs: isAuth ? 'flex' : 'none', md: 'none' } }}> {/* SMALL SCREEN */}
            <IconButton size="large" aria-label="account of current user" aria-controls="menu-appbar" aria-haspopup="true"
              onClick={(event: React.MouseEvent<HTMLElement>) => setAnchorElNav(event.currentTarget)} color="inherit" >
              <MenuIcon />
            </IconButton>
            <Menu id="menu-appbar" anchorEl={anchorElNav} keepMounted
              open={Boolean(anchorElNav)} onClose={() => setAnchorElNav(null)}
              sx={{ display: { xs: 'block', md: 'none' }, }}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
              }}
              transformOrigin={{
                vertical: 'top',
                horizontal: 'left',
              }} >
              <MenuItem sx={{ display: 'none' }} onClick={() => {
                setAnchorElNav(null)
                navigate('/about')
              }}><Typography textAlign="center">
                  About Us
                </Typography>
              </MenuItem>
              <MenuItem onClick={() => {
                setAnchorElNav(null)
                window.location.href = 'mailto:support@rentfinder.ai?subject=RentFinder%20Feedback'
              }}>
                <Typography textAlign="center">
                  Feedback
                </Typography>
              </MenuItem>
              <MenuItem onClick={() => {
                setAnchorElNav(null)
                navigate('/bulk')
              }}><Typography textAlign="center">
                  Bulk Estimates
                </Typography>
              </MenuItem>
              <MenuItem onClick={() => {
                setAnchorElNav(null)
                navigate('/subscription/price')
              }}><Typography textAlign="center">
                  Pricing
                </Typography>
              </MenuItem>
              {adminItems.map((e, i) => <MenuItem key={i} onClick={() => {
                navigate(e.path)
              }}>
                <Typography textAlign="center">
                  {e.label}
                </Typography>
              </MenuItem>)}
            </Menu>
          </Box>
          <Typography variant="h6" noWrap component="div" sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' } }}>
            <Button onClick={() => {
              setAnchorElNav(null)
              navigate('/home')
            }} sx={{ my: 2, color: grey[800], fontWeight: 'bold', display: 'block' }}>
              <img src="/images/logo140.png" width="32" />
            </Button>
          </Typography>
          <Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' }, justifyContent: 'space-between' }}> {/* LARGE SCREEN */}
            <Box sx={{ flexGrow: 0, display: 'flex', zIndex: 1, }}>
              <Button onClick={() => {
                setAnchorElNav(null)
                navigate('/home')
              }} sx={{ my: 1, pt: 1, color: grey[800], fontWeight: 'bold', display: 'block' }}>
                <img src={analysisData?.customize?.logoUrl ? analysisData?.customize?.logoUrl : `/images/v2/logo-menubar2.png`}
                  width={analysisData?.customize?.logoWidth ? analysisData?.customize?.logoWidth : 200} data-tour='home-logo' />
              </Button>
              <Button onClick={() => {
                setAnchorElNav(null)
                navigate('/about')
              }} sx={{ my: 2, color: grey[800], fontWeight: 'bold', display: 'none', textTransform: 'none' }} className='print-hide'>
                About Us
              </Button>
              <Button onClick={() => {
                setAnchorElNav(null)
                window.location.href = 'mailto:support@rentfinder.ai?subject=RentFinder%20Feedback'
              }}
                sx={{ my: 2, color: grey[800], fontWeight: 'bold', display: isAuth ? 'block' : 'none', textTransform: 'none' }} className='print-hide'>
                Feedback
              </Button>
              <Button onClick={() => {
                setAnchorElNav(null)
                navigate('/bulk')
              }} sx={{ my: 2, color: grey[800], fontWeight: 'bold', display: isAuth ? 'block' : 'none', textTransform: 'none' }} className='print-hide'>
                Bulk Estimates
              </Button>
              <Button onClick={() => {
                setAnchorElNav(null)
                navigate('/subscription/price')
              }} sx={{ my: 2, color: grey[800], fontWeight: 'bold', display: isAuth ? 'block' : 'none', textTransform: 'none' }} className='print-hide' data-tour='menu-pricing' >
                Pricing
              </Button>
              {adminItems.map((e, i) => <Button key={i} onClick={() => {
                navigate(e.path)
              }} sx={{ my: 2, color: grey[800], fontWeight: 'bold', display: isAuth ? 'block' : 'none', textTransform: 'none' }} className='print-hide'>
                {e.label}
              </Button>)}
            </Box>
          </Box>

          <Button sx={{ my: 2, textTransform: 'none' }} onClick={() => navigate('/home')} data-tour='menu-new-estimate' >
            <SearchIcon sx={{ fontSize: 18 }} /> <Typography component="span" sx={{ display: { xs: 'none', md: 'block' } }}>New Estimate</Typography>
          </Button>
          <Divider orientation="vertical" sx={{ mx: 3, height: '50px', alignSelf: 'center' }} flexItem />
          <Button sx={{ my: 2 }} onClick={() => navigate('/faq')} data-tour='menu-help'>
            <HelpOutlineIcon sx={{ fontSize: 18 }} />
          </Button>
          <Button sx={{ my: 2, display: { xs: 'none', md: 'block' } }} onClick={props.onOpenTour} data-tour='menu-tour'>
            <TourIcon sx={{ fontSize: 18 }} />
          </Button>
          <Divider orientation="vertical" sx={{ mx: 3, height: '50px', alignSelf: 'center' }} flexItem />


          {/* PROFILE START */}
          {isAuth && <Box sx={{ flexGrow: 0 }} className='print-hide'>
            <Tooltip title="Open settings">
              <Button onClick={(event: React.MouseEvent<HTMLElement>) => setAnchorElUser(event.currentTarget)} sx={{ p: 0, fontWeight: 'bold' }}>
                {user?.displayName?.substring(0, user?.displayName.indexOf(' '))}
                {anchorElUser ? <ExpandLessIcon /> : <ExpandMoreIcon />}
              </Button>
            </Tooltip>
            <Menu sx={{ mt: 4 }} id="menu-appbar" anchorEl={anchorElUser} keepMounted
              open={Boolean(anchorElUser)} onClose={() => setAnchorElUser(null)}
              anchorOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}>
              <MenuItem onClick={() => {
                navigate('/profile')
                setAnchorElUser(null)
              }}>
                <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                  <Avatar alt={user?.displayName ? user?.displayName as string : user?.email as string} src={user?.photoURL as string} />
                  <Typography variant='caption' textAlign="center" sx={{ color: domainCss?.instructionColor }}>{user?.email}</Typography>
                  <Typography variant='caption' textAlign="center" sx={{ color: domainCss?.instructionColor }}>Remaining: <strong>{!isNotOrgUser ? user?.org?.paidTierCount : user?.paidTierCount}</strong> reports</Typography>
                </Box>
              </MenuItem>
              <Divider />
              {user && user.authorities?.some(e => e.authority === 'ROLE_ORG_OWNER' || e.authority === 'ROLE_ORG_ADMIN') && <MenuItem onClick={() => {
                navigate('/admin/orgs')
                setAnchorElUser(null)
              }}>
                <Typography textAlign="center">Admin</Typography>
              </MenuItem>}
              {user && user.authorities?.some(e => e.authority === 'ROLE_ORG_OWNER' || e.authority === 'ROLE_ORG_ADMIN') && <MenuItem onClick={() => {
                navigate('/admin/userRpt')
                setAnchorElUser(null)
              }}>
                <Typography textAlign="center">User Report</Typography>
              </MenuItem>
              }
              {user && user.authorities?.some(e => e.authority === 'ROLE_API_ACCESS' || e.authority === 'ROLE_ADMIN') && <MenuItem onClick={() => {
                navigate('/api')
                setAnchorElUser(null)
              }}>
                <Typography textAlign="center">API</Typography>
              </MenuItem>
              }
              {user && user.authorities && !user.authorities?.some(e => e.authority === 'ROLE_ORG_OWNER' || e.authority === 'ROLE_ORG_ADMIN' || e.authority === 'ROLE_ORG_USER') && <MenuItem onClick={() => {
                // virgin users who do NOT belong to any org yet, can create their own org, operation=mynew
                navigate('/admin/orgs/mynew/0')
                setAnchorElUser(null)
              }}>
                <Typography textAlign="center">Create Org</Typography>
              </MenuItem>
              }
              {user && <MenuItem onClick={() => {
                navigate('/customize')
                setAnchorElUser(null)
              }} data-tour='menu-customize-report' >
                <Typography textAlign="center">Customize Report</Typography>
              </MenuItem>
              }
              <MenuItem onClick={() => {
                dispatch(signOutAsync({}))
                setAnchorElUser(null)
                navigate('/home')
                setLogoutSuccess(true)
              }}>
                <Typography textAlign="center">Signout</Typography>
              </MenuItem>
            </Menu>
          </Box>}
          {!isAuth && <Box sx={{ flexGrow: 0 }}>
            <Tooltip title="Signin">
              <IconButton onClick={() => navigate('/login')} sx={{ p: 0 }}>
                <Avatar alt={user?.displayName ? user?.displayName as string : user?.email as string} src={user?.photoURL as string} />
              </IconButton>
            </Tooltip>
          </Box>}
          {/* PROFILE END */}
        </Toolbar>
      </Container>

      <Snackbar open={logoutSuccess} autoHideDuration={6000} onClose={handleLogoutSuccess}>
        <Alert icon={<CheckIcon fontSize="inherit" />} onClose={handleLogoutSuccess} sx={{ width: '100%' }}>
          You've been successfully signed out of Rentfinder
        </Alert>
      </Snackbar>

    </AppBar>
  )
}
export default ResponsiveAppBar
